import AddIcon from '@mui/icons-material/Add';
import {styled} from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import {green} from '@mui/material/colors';
import {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import {ArchiveCheckbox} from '../../../../components/ArchiveCheckbox';
import {CONTRACT_CREATE_ROLES} from '../../../../shared/constants';
import {checkAuthorities} from '../../../../shared/helpers/checkAuthorities';
import {authState} from '../../../../store/auth/atoms';
import {setContractTableArchive, useContractsTableStore} from '../../stores/contracts-table.store';
import {ContractsTableFilters} from '../contracts-table-filters';
import {ContractsTableSearch} from './contracts-table-search';
import {useRecoilValue} from 'recoil';
import {useCompanyTariffGuard} from '../../../company-tariff';

export const ContractsTableToolbar: FC = () => {
  const navigate = useNavigate();
  const isArchived = useContractsTableStore((state) => state.archive);
  const {user} = useRecoilValue(authState);
  const {checkTariff, tariffLoading} = useCompanyTariffGuard();
  const canCreateContract = checkAuthorities(CONTRACT_CREATE_ROLES, [...(user?.roles || [])]);
  const toAddContractPage = () => {
    if (!checkTariff()) return;

    navigate('/contracts/addContract');
  };

  const handleArchiveToggle = (_: unknown, checked: boolean) => {
    setContractTableArchive(checked);
  };

  return (
    <ToolbarContainer>
      <ToolbarRow>
        <ContractsTableSearch />
        <Stack direction="row" gap={2} alignItems="center">
          <ArchiveCheckbox checked={isArchived} onChange={handleArchiveToggle} />

          <Tooltip title={canCreateContract ? 'Добавить контракт в систему' : 'Недостаточно прав'}>
            <AddButton
              onClick={toAddContractPage}
              variant="contained"
              size="small"
              startIcon={<AddIcon />}
              disabled={!canCreateContract || tariffLoading}
            >
              Добавить контракт
            </AddButton>
          </Tooltip>
        </Stack>
      </ToolbarRow>
      <ContractsTableFilters />
    </ToolbarContainer>
  );
};

const ToolbarContainer = styled(Toolbar)(({theme}) => ({
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 32,
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),

  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const ToolbarRow = styled(Stack)({
  width: '100%',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});

const AddButton = styled(Button)({
  height: '40px',
  fontSize: '0.87rem',
  letterSpacing: 0,
  textTransform: 'none',
  backgroundColor: green[500],

  '&:hover': {
    backgroundColor: green[600],
  },
});
